import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSettings } from '../hooks/useSettings';
import { useTranslation } from 'react-i18next';

interface SEOProps {
  title?: string;
  description?: string;
  url?: string;
  type?: string;
  image?: string;
}

const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  url = 'https://luaraadvocacia.com.br', 
  type = 'website',
  image
}) => {
  const { settings } = useSettings();
  const { t } = useTranslation();

  // Fallbacks do painel de settings ou traduções do i18n
  const finalTitle = title || settings?.default_seo_title || t('seo.home.title', 'Luara Rezende Advocacia | Direito do Trabalho e Condominial em Jundiaí');
  const finalDescription = description || settings?.default_seo_description || t('seo.home.description', 'Advocacia estratégica em Jundiaí e região. Atendimento em Direito do Trabalho para trabalhadores e empresas, além de assessoria jurídica para condomínios.');
  
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://luaraadvocacia.com.br';
  const finalUrl = url.startsWith('http') ? url : `${siteUrl}${url}`;
  const finalImage = image || `${siteUrl}/og-image.jpg`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={finalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={finalUrl} />
      <meta property="twitter:title" content={finalTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta property="twitter:image" content={finalImage} />
    </Helmet>
  );
};

export default SEO;
